<template>
  <span>{{ user.firstName }} {{ user.lastName }}</span>
</template>

<script>
export default {
  props: {
      user: {}
  },
};
</script>